/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  VRBO meta reducer
 */

import { nullReducer, payloadKeyReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'
import {
  CLEAR_VRBO_AVAILABILITY,
  DONE_FETCHING_VRBO_AVAILABILITY,
  ERROR_FETCHING_VRBO_AVAILABILITY,
  RECEIVE_VRBO_AVAILABILITY,
  START_FETCHING_VRBO_AVAILABILITY,
} from '../constants/index'

export const vrboMetaReducer = combineReducers({
  error: handleActions(
    {
      [ERROR_FETCHING_VRBO_AVAILABILITY]: payloadKeyReducer('error'),
      [combineActions(CLEAR_VRBO_AVAILABILITY, START_FETCHING_VRBO_AVAILABILITY)]: nullReducer,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_VRBO_AVAILABILITY]: () => true,
      [combineActions(CLEAR_VRBO_AVAILABILITY, DONE_FETCHING_VRBO_AVAILABILITY)]: () => false,
    },
    false
  ),
  fetchingKey: handleActions(
    {
      [START_FETCHING_VRBO_AVAILABILITY]: payloadKeyReducer('key'),
      [combineActions(CLEAR_VRBO_AVAILABILITY, DONE_FETCHING_VRBO_AVAILABILITY)]: nullReducer,
    },
    null
  ),
  currentKey: handleActions(
    {
      [CLEAR_VRBO_AVAILABILITY]: nullReducer,
      [RECEIVE_VRBO_AVAILABILITY]: payloadKeyReducer('key'),
    },
    null
  ),
})
